import React from "react";
import classNames from 'classnames'
import { Icon } from "@iconify/react";
import TopAd from './TopAd';

import "./TopBar.sass";

const urls = {
  diamond:
    "https://firebasestorage.googleapis.com/v0/b/chat-16a72.appspot.com/o/MTVRS-Icon.png?alt=media&token=aed29e84-d9bd-4697-9e74-1d1f29865dd7",
  logo: "https://firebasestorage.googleapis.com/v0/b/chat-16a72.appspot.com/o/metaverse_logo1.png?alt=media&token=87a1d53b-79e2-445b-8153-6ed28b4a2012",
};

export const TopBar: React.FC<{
  onClick: () => void;
  minimized: boolean;
}> = (props) => {

  const handleClick = () => {
    props.onClick();
  }

  return (
    <div className={"mvc-component-top-bar"} onClick={handleClick}>
      <div className="mvc-left-wrapper">
        <img className={"mvc-diamond"} src={urls.diamond} alt={""} />
        <span className={"mvc-logo-wrapper"}>
          <img className={classNames("mvc-logo-image", props.minimized && "minimized")} src={urls.logo} alt={""} />
          <span className={"mvc-logo-beta"}>beta</span>
        </span>
      </div>
      <Icon className={"mvc-layout-toggle"} icon={"bx:bx-window"} onClick={props.onClick} />
      {!props.minimized && (
        <TopAd />
      )}
    </div>
  );
};
